import axios from 'axios';
import { ErrorCode, IError } from '..';
import { pathOr, always } from 'rambda';
import { left, right, Either } from 'fp-ts/Either';
import { flow } from 'fp-ts/function';

export const getStatusMessage = (): Promise<
  Either<IError, { description: string }>
> => {
  return csosMessagesApi()
    .get(`v1/api/message/status`)
    .then(flow(pathOr({ description: '' }, 'data'), right))
    .catch(
      always(
        left({
          code: ErrorCode.GetMessageError,
          message: 'Failed to get the banner message.',
        })
      )
    );
};

const csosMessagesApi = flow(
  always({ baseURL: `${import.meta.env.VITE_API_MESSAGES_URL}` }),
  axios.create
);
